import Sidebar from "@/components/Sidebar";
import { Toaster } from "sonner";

export default function Layout({ children, title, subtitle, action }) {
  return (
    <div className="App flex min-h-screen bg-white">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="border-b border-[#E5E7EB] bg-white sticky top-0 z-10">
          <div className="px-8 py-5 flex items-end justify-between gap-4">
            <div>
              {subtitle && <div className="label-mono mb-1">{subtitle}</div>}
              <h1 className="font-display font-black text-2xl sm:text-3xl tracking-tight text-[#0F172A]">
                {title}
              </h1>
            </div>
            {action}
          </div>
        </header>
        <div className="px-8 py-8">{children}</div>
      </main>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
